var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-section',{staticClass:"pt-120 pb-70",attrs:{"area":"blog","title":"Entrevistas"}},[_c('b-row',[_vm._l((_vm.obCollection.models),function(article){return [_c('b-col',{key:`interview-item-${article.id}`,attrs:{"xs":"12","md":"6","xl":"4"}},[_c('interview-item',{attrs:{"item":article}})],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }